import { render, staticRenderFns } from "./CatalogWatermark.vue?vue&type=template&id=0c618dcf&"
import script from "./CatalogWatermark.vue?vue&type=script&lang=js&"
export * from "./CatalogWatermark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports